'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(({ className, ...props }, ref) => {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: generic component — htmlFor is passed via spread props at call sites
    <label ref={ref} className={cn('text-sm font-medium leading-none', className)} {...props} />
  );
});

Label.displayName = 'Label';

export { Label };
